import React from "react";
import Dum10Owl from "../../diamondCasinoAllGames/dum10/Dum10Owl";

const IMG = `${import.meta.env.BASE_URL}img/cards`;
const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

// Result slider: responsive items; an arrow moves the cards in view, 0.8 s slide, finger drag that
// snaps to a whole card.
const sliderItems = () => {
  const w = typeof window === "undefined" ? 1920 : window.innerWidth;
  if (w >= 600) return 8;
  if (w >= 500) return 6;
  if (w >= 411) return 5;
  return 4;
};

const DESC_LABELS = [["Winner "], ["Suit"], ["Odd/Even"], ["Joker"]];

/**
 * Reference result body for Andar Bahar 2 (CasinoResult "abj" branch):
 *   .row.row5.ab2-result > .col-12.col-lg-8 > .d-flex > .col-1.abj-title (A / B)
 *     + .abj-common-card (joker = card[0]) + .col-9 > 2 × .card-inner > .row.row5
 *       > .col-2 (first card: Andar card[2], Bahar card[1]) + .col-8 (owl of the rest) + .col-2 (winner icon)
 *   + .col-12.col-lg-4 (.casino-result-desc: Winner / Suit / Odd/Even / Joker = rdesc split on "#").
 * Rest of the cards: from index 3, odd → Bahar, even → Andar ("1" skipped).
 */
export default function AbjResultBody({ t1 }) {
  const cards = t1?.card ? String(t1.card).split(",") : [];
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const andar = [];
  const bahar = [];
  cards.forEach((c, i) => {
    if (c === "1" || i <= 2) return;
    (i % 2 !== 0 ? bahar : andar).push(c);
  });
  const win = String(t1?.win ?? "");

  const row = (id, first, list, winner) => (
    <div className="card-inner">
      <div className="row row5">
        <div className="col-2">
          <div className="casino-result-cards-item">
            <img src={`${IMG}/${first}.png`} alt="" />
          </div>
        </div>{" "}
        <div className="col-8">
          <Dum10Owl
            id={id}
            className="ab-slider owl-carousel owl-theme"
            items={sliderItems()}
            slideBy={sliderItems()}
            slideMs={800}
            drag
          >
            {list.map((c, i) => (
              <div key={`${i}-${c}`} className="casino-result-cards-item item">
                <img src={`${IMG}/${c}.png`} alt="" draggable={false} />
              </div>
            ))}
          </Dum10Owl>
        </div>{" "}
        <div className="col-2">
          {winner ? (
            <div className="casino-result-cards-item">
              <img src={WINNER_IMG} className="winner-icon" alt="" />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );

  return (
    <div className="row row5 ab2-result">
      <div className="col-12 col-lg-8">
        <div className="d-flex">
          <div className="col-1 abj-title">
            <div className="row row5">
              <div className="col-12">
                <b>A</b>
              </div>
            </div>{" "}
            <div className="row row5">
              <div className="col-12">
                <b>B</b>
              </div>
            </div>
          </div>{" "}
          <div className="abj-common-card">
            <div className="casino-result-cards-item">
              <img src={`${IMG}/${cards[0]}.png`} alt="" />
            </div>
          </div>{" "}
          <div className="col-9">
            {row("andarSlider", cards[2], andar, win === "1")}{" "}
            {row("baharSlider", cards[1], bahar, win === "2")}
          </div>
        </div>
      </div>{" "}
      <div className="col-12 col-lg-4">
        {desc.length ? (
          <div className="casino-result-desc">
            {DESC_LABELS.map(([label], k) => (
              <React.Fragment key={label}>
                {k ? " " : null}
                <div className="casino-result-desc-item">
                  <div>
                    {label}
                    <span className="float-right">:</span>
                  </div>{" "}
                  <div>{desc[k]}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
